import { apiWithoutAuth } from './client'

export const getLanguages = new Promise((resolve) => {
    apiWithoutAuth.get('v2/languages').then((res) => {
        resolve(res.data?.languages)
    })
})
